import { useState, useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

export const CounterAnimation = ({ 
  end, 
  prefix = "", 
  suffix = "", 
  duration = 2,
  className = ""
}) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (isInView && !hasAnimated.current) {
      hasAnimated.current = true;
      
      const totalSteps = 60; // 60 steps over the duration
      const stepDuration = (duration * 1000) / totalSteps;
      let currentStep = 0;

      const timer = setInterval(() => {
        currentStep++;
        const progress = currentStep / totalSteps;
        
        // Easing function (ease out cubic)
        const eased = 1 - Math.pow(1 - progress, 3);
        
        const newCount = Math.floor(eased * end);
        setCount(newCount);

        if (currentStep >= totalSteps) {
          clearInterval(timer);
          setCount(end); // Ensure we end at the exact target
        }
      }, stepDuration);

      return () => clearInterval(timer);
    }
  }, [isInView, end, duration]);

  return (
    <motion.span
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5 }}
      className={className}
    >
      {prefix}{count.toLocaleString()}{suffix}
    </motion.span>
  );
};
